import { LogoutIcon } from 'BreetAssets';
import { Prompt } from 'BreetComponents';
import { useAuthApi } from 'BreetHooks';
import { closeModal, useAppDispatch } from 'BreetRedux';
import { useCallback } from 'react';

export const DialogLogOut = () => {
	const { onLogout, isLoading } = useAuthApi();

	const dispatch = useAppDispatch();

	const closeLogoutModal = useCallback(() => {
		dispatch(closeModal('logout'));
	}, [dispatch]);

	return (
		<Prompt
			title='Log Out'
			description='Are you sure you want to Log Out?'
			cancelBtnText='No, Cancel'
			isLoading={isLoading}
			icon={<LogoutIcon />}
			onCancel={closeLogoutModal}
			onProceed={onLogout}
			proceedBtnText='Yes, Log Out'
		/>
	);
};
